<template>
	<page>
    <v-row justify="center">
      <v-col cols = "12" lg ="10">
		    <v-row justify="center" align="center">
			<v-col cols="12">
				<v-toolbar-title class="text-center textStyle" :style="{ direction: isRtl() ? 'rtl' : 'ltr !important' }">
					{{ $t("pages.newTypes.which") }}?
				</v-toolbar-title>
			</v-col>
		</v-row>
		    <div class="panel-container-outter">
			<div class="panel-container-inner">
				<v-row class="px-3" v-if="types" justify="center">
					<v-col cols="12" xs ="12" sm="6" md="4" lg="3" xl="2" v-for="type in typesToShow" :key="type.id" class="" >
						<type-circle :type="type" @showUpgrade="showUpgrade=true"/>
					</v-col>
				</v-row>
				<v-row v-if="hasMoreTypes">
					<v-col class="text-center mt-5">
						<v-btn color="#ED217C" dark @click="showMore=!showMore" class="mx-auto">
							<span v-if="!showMore">{{$t('pages.newTypes.moreLanguages')}}</span>
							<span v-else>{{ $t('pages.newTypes.showLess')}}</span>
						</v-btn>
					</v-col>
				</v-row>
			</div>
		</div>
      </v-col>
    </v-row>
    <popup-dialog v-model="welcomeDetailsModal" rounded-xl>
      <welcome-details @submit= "welcomeDetailsModal=false"/>
    </popup-dialog>
    <upgrade-dialog v-model="showUpgrade" />

	</page>
</template>

<script>
// import {types as gameTypes} from "src/store/modules/Game.module";
import {types as typeTypes} from "src/store/modules/Type.module";
import TypeCircle from "src/view/types/TypeCircle";
import WelcomeDetails from "src/view/dashboard/WelcomeDetails";
import { isRtl } from "src/locales";
import UpgradeDialog from "src/view/plans/UpgradeDialog";
export default {
	name: "types-circles",
	components: {
		TypeCircle,
    WelcomeDetails,
    UpgradeDialog,
	},
	data: () => {
		return {
			dialog: false,
			showMore: false,
      welcomeDetailsModal: false,
      isRtl,
      showUpgrade: false,
		};
	},
	computed: {
		types() {
			return this.$store.state.TypeModule.types.filter((type) => {
				return type.active == true;
			});
		},
		anotherLangType(){
			return this.types.filter((type) => {
				return type.language_id != null && type.language != null && type.language.code !== this.currentLanguage;
			});
		},
		filteredTypes(){
			return this.types.filter((type) => {
				return type.language_id == null || type.language.code === this.currentLanguage;
			});
		},
		hasMoreTypes(){
			return this.types.length > this.filteredTypes.length;
		},
		typesToShow(){
			if(this.showMore){
				return [...this.filteredTypes,...this.anotherLangType];
			}
			else{
				return this.filteredTypes;
			}
		},
		currentLanguage(){
			return this.$store.getters.selectedLanguage;
		}
	},
	methods: {
    openWelcomeDetailsModal() {
      const user = this.$store.state.AuthModule.user;
      return user.is_edu && !user.is_onboarding_complete
    }
	},
	async created() {
		// await this.$store.dispatch(gameTypes.FETCH);
		// this.$store.commit(gameTypes.CREATE, {});

    if (this.openWelcomeDetailsModal()){
      this.welcomeDetailsModal = true
    }
		if (this.types.length === 0) {
			await this.$store.dispatch(typeTypes.FETCH);
		}
	}
};
</script>

<style lang="scss" scoped>

.panel-container-outter {
  background-color:rgba(255, 255, 255, 0.3);
  border-radius:25px;
  box-shadow: rgb(100 100 111 / 20%) 0px 0px 14px 3px;
  padding: 10px;
  padding:10px;
  min-height:50vh;
  display: flex;
  flex-direction: column;
}
.panel-container-inner {
  background-color:rgba(255, 255, 255, 0.5);
  border-radius:20px;
  height:100%;
  padding:30px;
  flex-grow: 1;
}

.textStyle {
    color: white;
  font-size: 3.8rem;
  font-weight: bold;
  text-align: center;
	-webkit-text-stroke: 3px rgba(255,156,0,0.65);
	text-shadow: 0px 2px 9px #282828;
}
</style>
